// extracted by mini-css-extract-plugin
export default {"button":"fVjr-","flexContainer":"_1l1q9","count":"_3sJxs","switchCounterAndButton":"_37lTk","srOnly":"_3KwtW"};